import i18n from "i18next";
//import i18nBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import en from './i18n/en.json';
import it from './i18n/it.json';
import ro from './i18n/ro.json';

//const host = (window.location.host.indexOf('localhost') > -1)?"http://localhost:3000":"https://centrico-india.onrender.com";
const resources = {
    en: {translation: {...en}},
    it: {translation: {...it}},
    ro: {translation: {...ro}}
  };
i18n
    //.use(i18nBackend)
    .use(initReactI18next).init({
        resources,
        lng: "en",
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },
        // backend: {
        //     loadPath: `${host}/i18n/{{lng}}.json`,
        // }
});

export default i18n;